export const SPECIAL_CHARACTERS_PATTERN = /[!@#$%^&*()/_+{}"\[\]:;<>=,'-.?~\\|]/;

export const NEW_PASSWORD_PAGE_PATTERN =
  /^\/password\/[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;
